import { request } from '../boot/request';

// 获取买家地址列表
const getGMAddressList = params => {
  params = params || {};
  return request({
    url: '/customerAddressList',
    method: 'GET',
    params,
  });
};

// 提交地址
const saveGMAddress = params => {
  params = params || {};
  return request({
    url: '/createShippingAddress',
    method: 'POST',
    data: params,
  });
};

// 修改地址
const updateGMAddress = params => {
  params = params || {};
  return request({
    url: '/updateShippingAddress',
    method: 'POST',
    data: params,
  });
};

// 检测买家地址是否可配送
// "destination":"-6.245939419182807,105.78445231485978"
// lat, lng
const checkGMAddress = params => {
  params = params || {};
  return request({
    url: '/checkBuyerAddress',
    method: 'POST',
    data: params,
  });
};

export {
  getGMAddressList,
  saveGMAddress,
  updateGMAddress,
  checkGMAddress,
};
